/* -------------------------------------------------------------------------- */
/*                              Schema Quotations                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const quotation = new schema.Entity('quotations', {}, { idAttribute: 'quotationId' });
export const quotations = new schema.Array(quotation);
